export const getCurrency = (currency: any) => {
 let language = localStorage.getItem('language')
 if (language == 'CN') {
  if (currency == 'USD') {
   return '美元 '
  } else {
   return '港币 '
  }
 } else if (language == 'TW') {
  if (currency == 'USD') {
   return '美元 '
  } else {
   return '港幣 '
  }
 } else {
  if (currency == 'USD') {
   return 'USD '
  } else {
   return 'HKD '
  }
 }
}